import { cfgHasSports, FeatureSet, stateFeatureSet, stateUi, wantAtLeastReleaseStage } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
import { get } from 'svelte/store';
const mobileMenuUi = get(stateUi).mobileMenu;
const showRewardsAndPromo = mobileMenuUi.showRewardsAndPromo !== false;
const showChat = mobileMenuUi.showChat !== false;
const showSpecialBets = mobileMenuUi.showSpecialBets === true;
const showPoints = mobileMenuUi.showPoints === true;
const showSearch = mobileMenuUi.showSearch === true;
const showJackpot = mobileMenuUi.showJackpot === true;
const allMenuItems = [
    { name: Verbiage.menu, key: 'menu', icon: 'MobileMenuIcon', href: '/#/' },
    { name: Verbiage.sports, key: 'sports', icon: 'MobileSportsIcon', href: '/sports/' },
    {
        name: Verbiage.rewards,
        key: 'rewards',
        icon: 'GiftIcon',
        href: '/#/',
        isVisible: showRewardsAndPromo,
        isCentralButton: true,
        onlyLoggedIn: true
    },
    {
        name: Verbiage.promo,
        key: 'promo',
        icon: 'MobilePromotionIcon',
        href: '/promotion-page/',
        isVisible: showRewardsAndPromo,
        onlyNotLoggedIn: true
    },
    { name: Verbiage.casino, key: 'casino', icon: 'MobileCasinoIcon', href: '/casino/' },
    {
        name: Verbiage.chat,
        key: 'chat',
        icon: 'MobileChatIcon',
        href: '/#/',
        isVisible: showChat,
        onlyLoggedIn: get(stateFeatureSet) === FeatureSet.Release
    },
    {
        name: Verbiage.FOMO_bets02,
        key: 'special-bets',
        icon: 'MobileBetsIcon',
        href: '/special-bets/',
        isVisible: showSpecialBets
    },
    {
        name: Verbiage.fomo_points02,
        key: 'fomo-points',
        icon: 'PointsIcon',
        href: '/tournaments/#/fomo-airdrop/home',
        isVisible: showPoints
    },
    {
        name: Verbiage.search,
        key: 'search',
        icon: 'MobileSearchIcon',
        href: '/#/',
        isVisible: showSearch
    },
    {
        name: Verbiage.luna_bets,
        key: 'luna-special-bets',
        icon: 'MobileBetsIcon',
        href: '/special-bets/',
        isVisible: showSpecialBets
    },
    {
        name: Verbiage.luna_jackpot,
        key: 'jackpot',
        icon: 'MobileJackpotIcon',
        href: '/promotion-page/jackpot/',
        isVisible: showJackpot
    }
].filter((item) => cfgHasSports() || item.key !== 'sports');
export const getMenuItems = (featureSet, loggedIn, showFullScreenOnChatSlot = false) => {
    const filtered = allMenuItems.filter((item) => {
        const relOk = !item.rel || item.rel === featureSet;
        const stageOk = !item.stage || wantAtLeastReleaseStage(item.stage);
        const loggedOk = !item.onlyLoggedIn ||
            (item.onlyLoggedIn && loggedIn) ||
            (showFullScreenOnChatSlot && item.key === 'chat');
        const notLoggedOk = !item.onlyNotLoggedIn || (item.onlyNotLoggedIn && !loggedIn);
        const visibleOk = item.isVisible !== false;
        return relOk && stageOk && loggedOk && notLoggedOk && visibleOk;
    });
    const menuItems = filtered.map((item) => {
        if (item.key !== 'chat' || !showFullScreenOnChatSlot)
            return item;
        return {
            ...item,
            name: Verbiage.full_screen,
            icon: 'MobileFullScreenIcon'
        };
    });
    const order = mobileMenuUi.itemOrder;
    if (order) {
        return [...menuItems].sort((a, b) => {
            const keyA = a.key ?? '';
            const keyB = b.key ?? '';
            const ai = order.indexOf(keyA);
            const bi = order.indexOf(keyB);
            const max = order.length;
            return (ai === -1 ? max : ai) - (bi === -1 ? max : bi);
        });
    }
    return menuItems;
};
